// extracted by mini-css-extract-plugin
export default {"messageContainer":"Message_messageContainer__xmKh4","show":"Message_show__dPMyj","text":"Message_text__uYYYW","success":"Message_success__nmHaB","error":"Message_error__IZK80"};